/**
 * WorkspaceDetailStats - Stats cards section for workspace detail page
 * Displays key metrics like total keywords, unique searches, etc.
 */

import React from 'react';
import { BarChart, Search, TrendingUp, FileText as DocumentIcon } from 'lucide-react';
import SimpleStatCard from '@/modules/app/components/workspace/SimpleStatCard';

interface WorkspaceKeywordData {
  primary_keyword: string;
  search_volume?: number;
  data_type: string;
}

interface WorkspaceDetailStatsProps {
  allKeywordData: WorkspaceKeywordData[];
  isLoading: boolean;
}

const WorkspaceDetailStats: React.FC<WorkspaceDetailStatsProps> = ({
  allKeywordData,
  isLoading,
}) => {
  // Calculate stats using ALL data
  const stats = {
    totalKeywords: allKeywordData.length,
    uniqueSearches: new Set(allKeywordData.map(k => k.primary_keyword)).size,
    avgSearchVolume: allKeywordData.reduce((sum, k) => sum + (k.search_volume || 0), 0) / allKeywordData.length || 0,
    dataTypes: new Set(allKeywordData.map(k => k.data_type)).size
  };

  const workspaceStatsData = [
    { title: "Total Keywords", value: stats.totalKeywords.toString(), icon: BarChart },
    { title: "Unique Searches", value: stats.uniqueSearches.toString(), icon: Search },
    { title: "Avg. Search Volume", value: Math.round(stats.avgSearchVolume).toLocaleString(), icon: TrendingUp },
    { title: "Data Types", value: stats.dataTypes.toString(), icon: DocumentIcon },
  ];

  return (
    <div className="px-6 py-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {workspaceStatsData.map((stat) => (
          <SimpleStatCard
            key={stat.title}
            title={stat.title}
            value={stat.value}
            icon={stat.icon}
            isLoading={isLoading}
          />
        ))}
      </div>
    </div>
  );
};

export default WorkspaceDetailStats;